// extracted by mini-css-extract-plugin
export default {"desktopMinWidth":"769px","colorBlue":"#1a88f3","colorGreen":"#2ab764","colorGray":"#94a6cd","colorRed":"#f96057"};